import React, { FC, useEffect, useState } from 'react';
import PricingOption, { Plan } from 'components/feature/PricingOption/Index';
import useLocales from 'hooks/useLocales';
import Image from 'components/image/Image';
import FAQItems from 'components/feature/FAQitems';
import { faqItems } from 'core/constants/faqItems';
import Footer from 'components/Footer/Index';
import Navbar from 'components/Navbar';
import { SubscribtionPlansService } from 'services/subscribtionPlans/subscribtionPlans';

import './Index.scss';

const MembershipInfo: FC = (): JSX.Element => {
  const { t } = useLocales();
  const [plans, setPlans] = useState<Plan[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const handleGetPlanData = async () => {
    try {
      setLoading(true);
      const response = await SubscribtionPlansService.getPlans();
      setPlans(response);
    } catch (e) {
      console.error('Error fetching plans:', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetPlanData();
  }, []);

  return (
    <div
      className="memberInfo"
      style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
    >
      <Navbar />
      <div className="memberInfo__top" style={{ flex: 1 }}>
        <span className="memberInfo__top-title">{t('Our Pricing Option')}</span>
        <div className="memberInfo__top__pricing">
          {loading ? (
            <div className="memberInfo__loading">{t('Loading plans...')}</div>
          ) : (
            plans.map((plan, index) => {
              const isMiddle = index === 1;
              return (
                <PricingOption
                  key={plan.id}
                  className={isMiddle ? 'memberInfo__top__pricing-option' : ''}
                  t={t}
                  plan={plan}
                />
              );
            })
          )}
        </div>
      </div>
      <div className="memberInfo__include">
        <span className="memberInfo__include-title">
          {t('All plans include')}
        </span>
        <div className="memberInfo__include__plans">
          <div className="memberInfo__include__plans__items">
            <Image name="blue-check.svg" width={19} height={19} />
            <span className="memberInfo__include__plans__items-title">
              {t('Free talent assessment')}
            </span>
          </div>
          <div className="memberInfo__include__plans__items">
            <Image name="blue-check.svg" width={19} height={19} />
            <span className="memberInfo__include__plans__items-title">
              {t('Free personal branding page')}
            </span>
          </div>
          <div className="memberInfo__include__plans__items">
            <Image name="blue-check.svg" width={19} height={19} />
            <span className="memberInfo__include__plans__items-title">
              {t('No adds and no other spam!')}
            </span>
          </div>
          <div className="memberInfo__include__plans__items">
            <Image name="blue-check.svg" width={19} height={19} />
            <span className="memberInfo__include__plans__items-title">
              {t('You are in control over who has access to your data')}
            </span>
          </div>
          <div className="memberInfo__include__plans__items">
            <Image name="blue-check.svg" width={19} height={19} />
            <span className="memberInfo__include__plans__items-title">
              {t('Option to temporarily turn off your profile')}
            </span>
          </div>
          <div className="memberInfo__include__plans__items">
            <Image name="blue-check.svg" width={19} height={19} />
            <span className="memberInfo__include__plans__items-title">
              {t('Never look for your resume again, access wherever you are')}
            </span>
          </div>
        </div>
      </div>
      {/* <div className="memberInfo__accept">
        <span className="memberInfo__accept-title">
          {t('We accept the following payment methods')}
        </span>
        <div className="memberInfo__accept__methods">
          <span className="memberInfo__accept__methods-method">
            <Image name="deal.svg" width={74} height={66} />
          </span>
          <span className="memberInfo__accept__methods-method">
            <Image name="bank.svg" width={74} height={66} />
          </span>
        </div>
        <Image
          name="ssl.svg"
          className="memberInfo__accept-ssl"
          width={70}
          height={70}
        />
      </div> */}
      <div className="memberInfo__faq">
        {faqItems.map((item, index) => (
          <FAQItems
            key={index}
            title={item.title}
            description={item.description}
            number={`${index + 1 >= 10 ? index : `0${index + 1}`}`}
          />
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default MembershipInfo;
